/*
 * In OpenTelemetry (Otel), attributes use dots (.) as separators.
 * During the conversion from Otel to Prometheus, these dots are automatically replaced with underscores (_) to comply with Prometheus naming conventions.
 */

/**
 * Name of the application.
 *
 * @example infield
 */
export const ATTR_APP_NAME = 'app.name';

/**
 * Name or type of the browser.
 *
 * @example Chrome, Firefox
 */
export const ATTR_BROWSER = 'browser';

/**
 * Name of the project associated with the telemetry data.
 *
 * @example atlas-greenfield
 */

export const ATTR_PROJECT_NAME = 'project.name';

/**
 * Environment in which the application is running.
 *
 * @example production
 */
export const ATTR_ENVIRONMENT = 'app.environment';
